import ContentStorageAction from '../actions/ContentStorageAction';

export type ContentStorageState = { [key: string]: any };

export default function contentStorage(
  state: Readonly<ContentStorageState>,
  action: ContentStorageAction.Action,
): ContentStorageState {
  switch (action.type) {
    case ContentStorageAction.ActionType.PUT:
      return { ...state, [action.key]: action.value };
    case ContentStorageAction.ActionType.REMOVE: {
      const newState = { ...state };
      delete newState[action.key];
      return newState;
    }
  }
}
